import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAuthStore = defineStore('auth', () => {
  // State
  const isDevice = ref(localStorage.getItem('isDevice') === 'true')
  const isLoggedIn = ref(false)

  // Actions
  const setIsDevice = (status) => {
    isDevice.value = status
  }

  const setIsLoggedIn = (status) => {
    isLoggedIn.value = status
  }

  const updateDeviceStatus = (status) => {
    setIsDevice(status)
  }

  return {
    isDevice,
    isLoggedIn,
    setIsDevice,
    setIsLoggedIn,
    updateDeviceStatus
  }
}, {
  persist: true
})
